import { PropsWithChildren } from "react";
import styled from "styled-components";
import { useDisplay } from "../../contexts/display";

type PropsScoreDiv = {
    width?: number;
    className?: string;
}

const ScoreDiv = ({ className, children }: PropsWithChildren<PropsScoreDiv>) => {
    const { isMobile } = useDisplay();
    
    return <div className={`score-container ${className} ${isMobile && 'mobile-score-container'}`.trim()}>
        {children}
    </div>
}


export const Score = styled(ScoreDiv)`
    &.score-container.mobile-score-container {
        width: 65px;
        height: 65px;

        > .score-content {
            width: 55px;
            height: 55px;
        }
    }

    &.score-container {
        width: ${props => (props.width ?? 10) + 'rem'};
        height: ${props => (props.width ?? 10) + 'rem'};;
        background: ${props => props.theme.colors.primary};
        border-radius: 100%;
        display: flex;

        & > .score-content {
            width: ${props => ((props.width ?? 10) * 0.8) + 'rem'};
            height: ${props => ((props.width ?? 10) * 0.8) + 'rem'};
            background: #5d5d5d;
            border-radius: 100%;
            margin: auto;
            display: flex;

            & > img {
                margin: auto;
                width: ${props => ((props.width ?? 10) * 0.4) + 'rem'};
            }
        }
    }
`;


export const Container = styled('div')`
    display: flex;
    align-items: center;
    gap: 50px;
    justify-content: center;
    height: 100%;

    & > .element {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 10px;

        & > span {
            text-align: center;
            font-weight: 500;
        }
    }
`;